import classNames from 'classnames'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router'
import { Button, Image } from 'semantic-ui-react'
import { DirectUpload, t } from 'shared'
import { PreviewComponent, SingleImageUploadProps, UploadCb } from './types'
import { uploadButtonFactory } from './upload_button_factory'

export const SingleImageUpload = ({
  onUpload: onUpload_,
  imageUrl: imageUrl_,
  className,
  previewCmp: Preview = Image as PreviewComponent,
  previewClassName,
  cropBtnClassName,
  cropUrl,
  error,
  label,
}: SingleImageUploadProps) => {
  const [tempPhotoUrl, setTempPhotoUrl] = useState<string | undefined>(undefined)
  const imageUrl = useMemo(() => tempPhotoUrl ?? imageUrl_ ?? undefined, [tempPhotoUrl, imageUrl_])
  const Btn = useMemo(() => uploadButtonFactory(!!imageUrl, label), [imageUrl, label])
  const onUpload: UploadCb = useCallback(
    (photoId, photoUrl) => {
      setTempPhotoUrl(photoUrl)
      onUpload_(photoId, photoUrl)
    },
    [onUpload_]
  )
  useEffect(() => {
    if (!imageUrl_) return
    setTempPhotoUrl(undefined)
  }, [imageUrl_])

  return (
    <div className={classNames('flex flex-col', className)}>
      {imageUrl ? <Preview src={imageUrl} className={classNames(previewClassName)} /> : null}
      <div className="flex flex-1 gap-4 flex-wrap">
        {cropUrl && imageUrl && (
          <Button
            icon="crop"
            content={t('misc.change_cropping')}
            as={Link}
            to={cropUrl}
            className={classNames('m-0', cropBtnClassName)}
            primary
            basic
          />
        )}
        <DirectUpload onUpload={onUpload} triggerComponent={Btn} error={error ?? undefined} />
      </div>
    </div>
  )
}
